module.exports = __webpack_public_path__ + "static/img/v.cf6f30e7.png";